import Link from "next/link"

const ModalHeader = ({caption, closeOnClickMethod, showCloseButton=true, helpUrl }) => {
     return (
      // <div className="sticky top-0 bg-inherit items-start z-40 justify-between p-2 rounded-t-3xl">
          <div className="sticky top-0 bg-inherit flex items-center z-50 px-2 py-1 rounded-tl-3xl">
            <div className="flex py-4 justify-between w-full">
              <div>
          {showCloseButton && <button
         className="leading-tight p-1 bg-transparent border-0 text-gray-950 dark:text-gray-500 hover:text-slate-400 font-semibold outline-none focus:outline-none px-4 ease-linear durationw-300 ease-in-out "
            onClick={closeOnClickMethod}     
          >
         <span className="inline text-slate-700 dark:text-slate-500 hover:text-slate-400 duration-300 bg-transparent h-6 w-6 text-xl block outline-none focus:outline-none">
              {/* × */}
              <i className="fas fa-times text-slate-600 hover:text-slate-400 duration-300 "></i>
            </span>
          </button>}
          {/* <h3 className="p-6 text-slate-700 dark:text-slate-400 text-2xl font-base font-inter inline whitespace-nowrap">
            {caption}
          </h3> */}
          <h2 className="p-6 font-inter font-extralight text-2xl text-slate-700 dark:text-slate-400 inline whitespace-nowrap">
                   {caption}
          </h2>
          </div>
          {helpUrl && <Link target="_blank" href={helpUrl} className="mx-4 border-2 h-10 w-10 flex items-center justify-center p-2 rounded-full text-slate-300 border-slate-300 hover:border-slate-400 hover:text-slate-400">
            <i className="fa-solid fa-question text-sm"></i>
            </Link>}
          </div>
        </div>
        // </div>
     )
}

export default ModalHeader